import * as React from "react";
import { Link } from "@ludens-reklame/rubics-v3-sdk/link/types";
import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { createLinkProps } from "../../hooks/useLinkProps.js";
import { Title, Grid, Card, CardTitle, CardIcon } from "./styles.js";
import type { BackgroundColor } from "../../types/theme.js";

export interface ServiceGridV2Card {
  icon?: string;
  link?: Link;
}

export interface Props {
  title?: string;
  cards?: ServiceGridV2Card[];
  backgroundColor?: BackgroundColor;
}

export const ServiceGridV2: React.FC<Props> = ({
  title,
  cards = [],
  backgroundColor,
}) => {
  const validCards = cards.filter((card) => card.link?.url);

  if (!title && validCards.length === 0) return null;

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer>
          {title && (
            <Title {...createEditableProps("text", "title")}>{title}</Title>
          )}
          <Grid>
            {validCards.map((card, index) => (
              <Card
                key={index}
                className="service-card"
                $bg={backgroundColor}
                {...createLinkProps(card.link!)}
              >
                <CardTitle>{card.link!.title}</CardTitle>
                {card.icon && (
                  <CardIcon
                    className="icon-slot"
                    dangerouslySetInnerHTML={{ __html: card.icon }}
                  />
                )}
              </Card>
            ))}
          </Grid>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};
